/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { ButtonBase, Icon } from "../../core";
import { IFieldValidationError } from "../FieldTypes";
import { FieldStatus } from "../FieldStatus";

import "./FieldResourceSelector.scss";

export interface IFieldResourceSelectorProps {
	children?: React.ReactNode;
	className?: string;
	onClick?: React.MouseEventHandler;
	errors?: IFieldValidationError[];
	disabled?: boolean;
	endAdornment?: React.ReactNode;
	tooltip?: string;
}

export const FieldResourceSelector = React.forwardRef<HTMLButtonElement, IFieldResourceSelectorProps>(
	({ children, className, onClick, errors, disabled, endAdornment, tooltip }, ref) => {
		const baseClass = BEM("edt-field-resource-selector");

		if (className) {
			baseClass.add(className);
		}

		return (
			<div className={baseClass.toClassName()}>
				<ButtonBase
					onClick={onClick}
					disabled={disabled}
					className={baseClass.element("button").toClassName()}
					ref={ref}
					title={tooltip}
				>
					<div className={baseClass.element("icon-wrapper").toClassName()}>
						<Icon className={baseClass.element("icon").toClassName()} name="mdi/folder-open" />
					</div>
					<span className={baseClass.element("value").toClassName()}>{children}</span>
					<FieldStatus errors={errors} />
				</ButtonBase>
				{endAdornment}
			</div>
		);
	}
);
